import React from 'react';
export function Footer() {
  return <footer className="bg-teal text-white pt-16 pb-24 md:pb-16" data-id="element-38">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-40">
          <div data-id="element-41">
            <h2 className="font-serif text-2xl mb-4 text-cream" data-id="element-42">
              The Cortisol Reset
            </h2>
            <p className="text-teal-muted text-sm max-w-sm text-cream/70" data-id="element-43">
              Science-backed protocols for busy women to reclaim their energy,
              balance hormones, and live without burnout.
            </p>
          </div>
          <div className="flex flex-col md:items-end space-y-2" data-id="element-44">
            <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-45">
              Support
            </a>
            <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-46">
              Terms of Service
            </a>
            <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-47">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-48">
              Refund Policy
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8" data-id="element-49">
          <p className="text-xs text-cream/50 leading-relaxed mb-4" data-id="element-50">
            Disclaimer: The information provided in this program is for
            educational purposes only and is not intended as medical advice.
            Always consult with a qualified healthcare professional before
            beginning any new diet or exercise program, especially if you have
            pre-existing health conditions or are pregnant. Results may vary.
          </p>
          <p className="text-xs text-cream/50" data-id="element-51">
            &copy; {new Date().getFullYear()} The Cortisol Reset. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}